module.exports = __webpack_public_path__ + "static/media/main.328a89a3.png";